/*
 * Harbour Roast — coffee summary card (Style A, "Sand Panel"), Oct 2026.
 * Desktop (hover-capable pointer): hovering a coffee's image swaps it for a sand panel
 *   with roast level, tasting notes, origin / process / varietal / roast date, Quick add and a product link.
 * Touch: a small "i" button on each coffee image opens a bottom sheet with the same details,
 *   and the first two tasting notes are shown under the roaster name.
 * Runs on collection pages and on the home page "Current Selection" carousel (layout/theme.liquid).
 * Data: /collections/<handle>?view=hr-cards (templates/collection.hr-cards.liquid), built
 *   from the custom.notes / region / process / varietal / brew_method / roast_date metafields.
 * Works alongside collection-filters.js (cards it imports from later pages are decorated too).
 * Products without data (e.g. equipment) are left untouched.
 */
(function () {
  if (window.__hrCoffeeCard) return;
  window.__hrCoffeeCard = true;

  // Collection pages: data comes from the collection in the URL. Other pages (e.g. the home
  // page carousel) name their collection on the script tag: data-collection="current-selection".
  var me = document.currentScript;
  var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
  var COLLECTION = (me && me.getAttribute('data-collection')) || (m && m[1]);
  if (!COLLECTION) return;
  var DATA = null;
  var CAN_HOVER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function list(a) {
    a = (a || []).filter(Boolean);
    if (a.length < 2) return a.join('');
    return a.slice(0, -1).join(', ') + ' & ' + a[a.length - 1];
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    if (p.length !== 3) return '';
    return (+p[2]) + ' ' + MONTHS[(+p[1]) - 1] + ' ' + p[0];
  }
  // process values that are really product types (the filter excludes these too)
  var NOT_PROCESS = ['blend', 'espresso blend'];
  function procs(a) { return uniq(a).filter(function (x) { return NOT_PROCESS.indexOf(String(x).toLowerCase()) === -1; }); }
  function uniq(a) { var o = []; (a || []).forEach(function (x) { if (x && o.indexOf(x) === -1) o.push(x); }); return o; }

  var CSS = [
    '.hrc-panel{position:absolute;inset:0;z-index:4;box-sizing:border-box;padding:clamp(14px,7cqi,22px);display:flex;flex-direction:column;gap:clamp(8px,4cqi,14px);background:#f4efe6;color:#1b2a4a;cursor:pointer;opacity:0;visibility:hidden;transform:translateY(6px);transition:opacity .18s ease,transform .18s ease,visibility 0s linear .18s;container-type:size;text-align:left}',
    'product-card:hover .hrc-panel,product-card:focus-within .hrc-panel{opacity:1;visibility:visible;transform:none;transition:opacity .18s ease .08s,transform .18s ease .08s,visibility 0s}',
    '.hrc-top{display:flex;align-items:center;justify-content:space-between;gap:8px;min-height:24px}',
    '.hrc-eyebrow{font-family:"Bebas Neue",sans-serif;font-size:15px;letter-spacing:.08em;line-height:1;color:#1a7a6d}',
    '.hrc-roast{font-family:"Bebas Neue",sans-serif;font-size:14px;letter-spacing:.06em;line-height:1;color:#1b2a4a;border:1px solid #1b2a4a;border-radius:999px;padding:5px 10px 4px;white-space:nowrap;margin-left:auto}',
    '.hrc-notes{font-family:Maragsa,serif!important;font-size:clamp(17px,10cqi,25px);line-height:1.12;color:#1b2a4a;margin:0;padding-bottom:3px;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden}',
    '.hrc-notes.is-long{font-size:clamp(15px,8.4cqi,21px)}',
    '.hrc-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px 12px;margin:0}',
    '.hrc-grid div{display:flex;flex-direction:column;gap:1px;min-width:0}',
    '.hrc-grid dt{font-family:"Bebas Neue",sans-serif;font-size:13px;letter-spacing:.06em;line-height:1.1;color:#5a6275}',
    '.hrc-grid dd{margin:0;font-size:15px;letter-spacing:.02em;line-height:1.15;color:#1b2a4a;overflow-wrap:anywhere}',
    '.hrc-actions{margin-top:auto;display:flex;flex-direction:column;gap:8px}',
    '.hrc-add{height:44px;border:1.5px solid #1b2a4a;background:transparent;border-radius:999px;font-family:"Bebas Neue",sans-serif;font-size:18px;letter-spacing:.06em;color:#1b2a4a;cursor:pointer;padding:0 12px;transition:background .15s,color .15s}',
    '.hrc-add:hover,.hrc-add:focus-visible{background:#1b2a4a;color:#fff}',
    '.hrc-view{font-size:16px;letter-spacing:.04em;text-align:center;color:#1b2a4a;text-decoration:none}',
    '.hrc-view:hover{color:#1a7a6d}',
    '@container (max-height: 300px){.hrc-view{display:none}.hrc-grid{gap:6px 10px}}',
    '@container (max-height: 250px){.hrc-eyebrow{display:none}}',
    '@media (prefers-reduced-motion: reduce){.hrc-panel{transition:none!important;transform:none!important}}',
    /* touch: info button, notes line, bottom sheet */
    '.hrc-info{position:absolute;top:2px;right:2px;z-index:4;width:44px;height:44px;border:0;background:transparent;padding:0;display:flex;align-items:center;justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.hrc-info span{width:28px;height:28px;border-radius:999px;background:#fff;box-shadow:0 2px 6px rgba(27,42,74,.18);display:flex;align-items:center;justify-content:center;font-family:Maragsa,serif!important;font-size:16px;line-height:1;color:#1b2a4a}',
    '.hrc-mininotes{font-size:14px;letter-spacing:.02em;line-height:1.3;color:#5a6275;margin:2px 0 0;align-self:stretch;width:100%;box-sizing:border-box;text-align:center;overflow-wrap:anywhere;text-wrap:balance}',
    '.hrc-scrim{position:fixed;inset:0;z-index:2147483000;background:rgba(20,20,20,.45);opacity:0;transition:opacity .2s}',
    '.hrc-sheet{position:fixed;left:0;right:0;bottom:0;z-index:2147483001;max-height:88vh;overflow-y:auto;background:#fff;border-radius:20px 20px 0 0;box-sizing:border-box;padding:10px 20px calc(20px + env(safe-area-inset-bottom));display:flex;flex-direction:column;gap:16px;color:#1b2a4a;font-family:var(--font-body--family,Helvetica,Arial,sans-serif);transform:translateY(100%);transition:transform .25s ease;text-align:left}',
    '.hrc-open .hrc-scrim{opacity:1}.hrc-open .hrc-sheet{transform:none}',
    '.hrc-grab{align-self:center;width:40px;height:5px;border-radius:999px;background:#d8d3ca;flex-shrink:0}',
    '.hrc-head{display:flex;gap:14px;align-items:center}',
    '.hrc-thumb{width:84px;height:84px;flex-shrink:0;border-radius:10px;background:#f7f5f1;display:flex;align-items:center;justify-content:center;overflow:hidden}',
    '.hrc-thumb img{width:88%;height:88%;object-fit:contain}',
    '.hrc-titles{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}',
    '.hrc-kicker{font-family:"Bebas Neue",sans-serif;font-size:14px;letter-spacing:.08em;color:#1a7a6d}',
    '.hrc-name{font-family:Maragsa,serif!important;font-size:26px;line-height:1.05;margin:0;color:#1b2a4a}',
    '.hrc-price{font-family:"Bebas Neue",sans-serif;font-size:17px;letter-spacing:.04em}',
    '.hrc-close{align-self:flex-start;width:44px;height:44px;border:0;background:transparent;padding:0;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#1b2a4a}',
    '.hrc-label{font-family:"Bebas Neue",sans-serif;font-size:14px;letter-spacing:.08em;color:#5a6275;margin:0 0 8px}',
    '.hrc-pills{display:flex;flex-wrap:wrap;gap:6px;margin:0;padding:0;list-style:none}',
    '.hrc-pills li{font-size:15px;letter-spacing:.03em;padding:6px 12px;border-radius:999px;background:#f4efe6;color:#5b4425}',
    '.hrc-pills li:nth-child(-n+2){background:#fbeee8;color:#8a3f22}',
    '.hrc-rows{margin:0}',
    '.hrc-rows div{display:flex;justify-content:space-between;gap:12px;padding:9px 0;border-top:1px solid #ece7de;font-size:16px;letter-spacing:.02em}',
    '.hrc-rows div:last-child{border-bottom:1px solid #ece7de}',
    '.hrc-rows dt{font-family:"Bebas Neue",sans-serif;font-size:15px;letter-spacing:.06em;color:#5a6275}',
    '.hrc-rows dd{margin:0;text-align:right}',
    '.hrc-cta{display:flex;flex-direction:column;gap:6px}',
    '.hrc-buy{height:50px;border:0;background:#1a7a6d;border-radius:999px;font-family:"Bebas Neue",sans-serif;font-size:20px;letter-spacing:.06em;color:#fff;cursor:pointer}',
    '.hrc-buy[disabled]{background:#c9c4ba;cursor:default}',
    '.hrc-full{height:44px;display:flex;align-items:center;justify-content:center;font-size:17px;letter-spacing:.04em;color:#1b2a4a;text-decoration:none}',
    'html.hrc-lock,html.hrc-lock body{overflow:hidden}'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('hrc-style')) return;
    var s = document.createElement('style');
    s.id = 'hrc-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var mm = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
    return mm ? mm[1] : null;
  }
  function urlOf(card) {
    var a = card.querySelector('a.product-card__link[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : null;
  }
  function themeAdd(card) { return card.querySelector('.quick-add__button, quick-add-component button[type="submit"], quick-add-component button'); }

  function details(d) {
    var rows = [];
    var o = uniq(d.o); if (o.length) rows.push(['Origin', o.join(', ')]);
    var p = procs(d.p); if (p.length) rows.push(['Process', p.join(', ')]);
    var v = uniq(d.v); if (v.length) rows.push(['Varietal', v.join(', ')]);
    if (d.r) rows.push(['Roasted', fmtDate(d.r)]);
    return rows;
  }

  function buildPanel(card, gallery, d) {
    var notes = uniq(d.n).slice(0, 4);
    var rows = details(d).slice(0, 4);
    var url = urlOf(card);
    var addBtn = themeAdd(card);
    var canAdd = d.a && addBtn && !addBtn.disabled;
    var headline = notes.length ? list(notes) : (procs(d.p).join(', ') || '');
    var html = '';
    if (notes.length || d.l) {
      html += '<div class="hrc-top">' + (notes.length ? '<span class="hrc-eyebrow">Tastes like</span>' : '') +
        (d.l ? '<span class="hrc-roast">' + esc(d.l) + ' roast</span>' : '') + '</div>';
    }
    if (headline) html += '<p class="hrc-notes' + (headline.length > 48 ? ' is-long' : '') + '">' + esc(headline) + '</p>';
    if (rows.length) {
      html += '<dl class="hrc-grid">' + rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>';
    }
    html += '<div class="hrc-actions">';
    if (canAdd) html += '<button type="button" class="hrc-add">Quick add</button>';
    if (url) html += '<a class="hrc-view" href="' + esc(url) + '">' + (canAdd ? 'View coffee →' : (d.a ? 'View coffee →' : 'Sold out · view coffee →')) + '</a>';
    html += '</div>';

    var panel = document.createElement('div');
    panel.className = 'hrc-panel';
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML = html;
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.hrc-add')) {
        e.preventDefault(); e.stopPropagation();
        var b = themeAdd(card); if (b) b.click();
        return;
      }
      if (e.target.closest('a')) { e.stopPropagation(); return; }
      e.preventDefault(); e.stopPropagation();
      if (url) location.href = url;
    });
    // Panel content stays out of the tab order / screen readers: the card's own link and
    // the theme's quick-add remain the accessible path, so nothing is announced twice.
    panel.querySelectorAll('a,button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
    gallery.appendChild(panel);
  }

  function buildTouch(card, gallery, d) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hrc-info';
    var nameEl = card.querySelector('h5, h3, .visually-hidden');
    var name = nameEl ? nameEl.textContent.trim() : 'this coffee';
    btn.setAttribute('aria-label', 'Show details for ' + name);
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = '<span aria-hidden="true">i</span>';
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openSheet(card, d, btn); });
    gallery.appendChild(btn);

    var notes = uniq(d.n).slice(0, 3);
    var price = card.querySelector('product-price');
    if (notes.length && price && price.parentElement && !card.querySelector('.hrc-mininotes')) {
      var line = document.createElement('p');
      line.className = 'hrc-mininotes';
      line.textContent = notes.join(' · ');
      price.parentElement.insertBefore(line, price);
    }
  }

  /* ---------- bottom sheet ---------- */
  var sheetWrap = null, lastTrigger = null;
  function closeSheet() {
    if (!sheetWrap) return;
    var w = sheetWrap; sheetWrap = null;
    w.classList.remove('hrc-open');
    document.documentElement.classList.remove('hrc-lock');
    document.removeEventListener('keydown', onKey, true);
    setTimeout(function () { w.remove(); }, 260);
    if (lastTrigger) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key === 'Tab' && sheetWrap) {
      var f = sheetWrap.querySelectorAll('button:not([disabled]),a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function openSheet(card, d, trigger) {
    closeSheet();
    lastTrigger = trigger;
    var nameEl = card.querySelector('h5') || card.querySelector('h3');
    var name = nameEl ? nameEl.textContent.trim() : '';
    var vendorEl = card.querySelector('.group-block-content p');
    var vendor = vendorEl ? vendorEl.textContent.trim() : '';
    var priceEl = card.querySelector('product-price .price, .price');
    var price = priceEl ? priceEl.textContent.trim() : '';
    var img = card.querySelector('.card-gallery img');
    var imgSrc = img ? (img.currentSrc || img.getAttribute('src')) : '';
    var url = urlOf(card);
    var addBtn = themeAdd(card);
    var canAdd = d.a && addBtn && !addBtn.disabled;
    var notes = uniq(d.n);
    var rows = [];
    var o = uniq(d.o); if (o.length) rows.push(['Origin', o.join(', ')]);
    var p = procs(d.p); if (p.length) rows.push(['Process', p.join(', ')]);
    var v = uniq(d.v); if (v.length) rows.push(['Varietal', v.join(', ')]);
    var b = uniq(d.b); if (b.length) rows.push(['Best for', list(b)]);
    if (d.r) rows.push(['Roasted', fmtDate(d.r)]);
    var kicker = [vendor, d.l ? d.l + ' roast' : ''].filter(Boolean).join(' · ');
    var id = 'hrc-sheet-title';

    var html = '<div class="hrc-scrim"></div>' +
      '<div class="hrc-sheet" role="dialog" aria-modal="true" aria-labelledby="' + id + '">' +
      '<div class="hrc-grab" aria-hidden="true"></div>' +
      '<div class="hrc-head">' +
      (imgSrc ? '<div class="hrc-thumb"><img src="' + esc(imgSrc) + '" alt=""></div>' : '') +
      '<div class="hrc-titles">' + (kicker ? '<span class="hrc-kicker">' + esc(kicker) + '</span>' : '') +
      '<h2 class="hrc-name" id="' + id + '">' + esc(name) + '</h2>' +
      (price ? '<span class="hrc-price">' + esc(price) + '</span>' : '') + '</div>' +
      '<button type="button" class="hrc-close" aria-label="Close details"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg></button>' +
      '</div>';
    if (notes.length) html += '<div><p class="hrc-label">Tasting notes</p><ul class="hrc-pills">' + notes.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('') + '</ul></div>';
    if (rows.length) html += '<dl class="hrc-rows">' + rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>';
    html += '<div class="hrc-cta">' +
      (canAdd ? '<button type="button" class="hrc-buy">Add to cart' + (price ? ' · ' + esc(price.replace(/\s*USD$/, '')) : '') + '</button>'
        : (d.a && url) ? '<a class="hrc-buy" style="display:flex;align-items:center;justify-content:center;text-decoration:none" href="' + esc(url) + '">Choose options</a>'
        : '<button type="button" class="hrc-buy" disabled>Sold out</button>') +
      (url ? '<a class="hrc-full" href="' + esc(url) + '">View full details →</a>' : '') +
      '</div></div>';

    var w = document.createElement('div');
    w.className = 'hrc-sheet-wrap';
    w.innerHTML = html;
    document.body.appendChild(w);
    sheetWrap = w;
    document.documentElement.classList.add('hrc-lock');
    w.querySelector('.hrc-scrim').addEventListener('click', closeSheet);
    w.querySelector('.hrc-close').addEventListener('click', closeSheet);
    var buy = w.querySelector('.hrc-buy:not([disabled])');
    if (buy) buy.addEventListener('click', function () {
      closeSheet();
      var tb = themeAdd(card);
      if (tb) setTimeout(function () { tb.click(); }, 280);
    });
    document.addEventListener('keydown', onKey, true);
    // simple swipe-down to close
    var sheet = w.querySelector('.hrc-sheet'), y0 = null;
    sheet.addEventListener('touchstart', function (e) { y0 = sheet.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    sheet.addEventListener('touchend', function (e) { if (y0 != null && e.changedTouches[0].clientY - y0 > 80) closeSheet(); y0 = null; }, { passive: true });
    setTimeout(function () { w.classList.add('hrc-open'); w.querySelector('.hrc-close').focus({ preventScroll: true }); }, 20);
  }

  /* ---------- decorate cards ---------- */
  function decorate(root) {
    if (!DATA) return;
    (root || document).querySelectorAll('product-card').forEach(function (card) {
      if (card.dataset.hrc) return;
      var h = handleOf(card);
      var d = h && DATA[h];
      card.dataset.hrc = d ? '1' : '0';
      if (!d) return;
      var gallery = card.querySelector('.card-gallery');
      if (!gallery) return;
      if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
      if (CAN_HOVER) buildPanel(card, gallery, d); else buildTouch(card, gallery, d);
    });
  }

  function start() {
    if (!document.querySelector('product-card')) return;
    fetch('/collections/' + COLLECTION + '?view=hr-cards', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        try { DATA = JSON.parse(t); } catch (e) { DATA = null; }
        if (!DATA || !Object.keys(DATA).length) return;
        injectCSS();
        decorate(document);
        // cards added later (filter script pulling in page 2+, theme re-renders)
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { decorate(document); break; }
        }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
